import firebase from "./firebase";
const logEvent = firebase.analytics().logEvent;
export { logEvent };
